import React, {useState,useEffect} from 'react';
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
//import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
//import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
//import FolderIcon from '@mui/icons-material/Mail';
import EmailIcon from '@mui/icons-material/Email';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
//import BookIcon from '@mui/icons-material/Book';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {Listset,Owner,OwnerMails} from './Inc';
import RowData from './RowData';
import Ajax from './Ajax';
import Loading from './Loading';
import Title from './Title';
import MailsHour from './MailsHour';
import MailsRemaining from './MailsRemaining';
import {Theme} from './Theme';
//import { loadImage } from 'browser-image-compression';

interface MailsProps {
    owner:Owner,
}

const Mails = (props:MailsProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        isLoading:false,
		isMailsHour:false,
		isMailsRemaining:false,
		checks: {
			daily: false,
			ordered: false,
			soldout: false,
			remaining: false,
			canceled: false,
			lottery_start: false,
			lottery_end: false,
			daily_hour: 0,
			min_remaining: 1,
		} as OwnerMails,
    });
	let owner_name = "未登録";
    if( props.owner.owner_id>0 ){
        owner_name = props.owner.owner_name;
    }
	const changeChecked = (index:number)=>{
		const name = menuKeys[index] as keyof OwnerMails;
		const value = !states.checks[name];
		if( name==="daily" && value===true ){
			openMailsHour();
			return;
		}
		if( name==="remaining" && value===true ){
			openMailsRemaining();
			return;
		}
		const checks = {...states.checks,[name]:value};
		setStates({checks:checks, isLoading:true,isMailsHour:false,isMailsRemaining:false});
        Ajax.send("ownermail/update",{key:name,value:value},(res:any)=>{
			//console.log(res);
			if( res.ok ){
				setStates({checks:checks, isLoading:false,isMailsHour:false,isMailsRemaining:false});
			} else {
				setStates({...states,isLoading:false});
			}
		},(res:any)=>{
			setStates({...states,isLoading:false});	
		});		
	}
	//const changeSwitch = async (event: React.ChangeEvent<HTMLInputElement>) => {
	//	const key = event.target.name;
	//	let value = "0";
	//	if( event.target.checked ){
	//		value = "1";
	//	}
	//	const checks = {...states.checks,[key]:event.target.checked};
	//	//const checks = {...states.checks};
		
	//	setStates({checks:checks, isLoading:true,isMailsHour:false});
    //    Ajax.send("ownermail/update",{key:key,value:value},(res:any)=>{
	//		//console.log(res);
	//		if( res.ok ){
	//			setStates({checks:checks, isLoading:false,isMailsHour:false});
	//		} else {
	//			setStates({...states,isLoading:false});
	//		}
	//	},(res:any)=>{
	//		setStates({...states,isLoading:false});	
	//	});
	//};

	const updateMailsHour = (hour:number)=>{
		const checks = {...states.checks,daily:true,daily_hour:hour};
		setStates({checks:checks, isLoading:true,isMailsHour:false,isMailsRemaining:false});
        Ajax.send("ownermail/update",{key:'daily',value:true,hour:hour},(res:any)=>{
			if( res.ok ){
				setStates({checks:checks, isLoading:false,isMailsHour:false,isMailsRemaining:false});
			} else {
				setStates({...states,isLoading:false});
			}
		},(res:any)=>{
			setStates({...states,isLoading:false});	
		});		
	}
	const openMailsHour = ()=>{
		setStates({...states,isMailsHour:true});
	}
	const closeMailsHour = ()=>{
		setStates({...states,isMailsHour:false});
	}

	const updateMailsRemaining = (min:number)=>{
		const checks = {...states.checks,remaining:true,min_remaining:min};
		setStates({checks:checks, isLoading:true,isMailsHour:false,isMailsRemaining:false});
        Ajax.send("ownermail/update",{key:'remaining',value:true,min:min},(res:any)=>{
			if( res.ok ){
				setStates({checks:checks, isLoading:false,isMailsHour:false,isMailsRemaining:false});
			} else {
				setStates({...states,isLoading:false});
			}
		},(res:any)=>{
			setStates({...states,isLoading:false});	
		});		
	}
	const openMailsRemaining = ()=>{
		setStates({...states,isMailsRemaining:true});
	}
	const closeMailsRemaining = ()=>{
		setStates({...states,isMailsRemaining:false});
	}
	const load = async ()=>{
        await Ajax.send("ownermail/get",{},(res:any)=>{
			//console.log(res.checks);
			if( res.ok ){
				setStates({checks:{
					daily: res.checks.daily==="1" ? true:false,
					ordered: res.checks.ordered==="1" ? true:false,
					soldout: res.checks.soldout==="1" ? true:false,
					remaining: res.checks.remaining==="1" ? true:false,
					canceled: res.checks.canceled==="1" ? true:false,
					lottery_start: res.checks.lottery_start==="1" ? true:false,
					lottery_end: res.checks.lottery_end==="1" ? true:false,
					daily_hour: res.checks.daily_hour,
					min_remaining: res.checks.min_remaining,
				}, isLoading:false,isMailsHour:false,isMailsRemaining:false});
			} else {
				setStates({...states,isLoading:false});
			}
		},(res:any)=>{
			setStates({...states,isLoading:false});	
		});
	}
    useEffect( ()=>{
        window.scrollTo(0,0);
		load();
    } ,[]);

	const menuKeys = Object.keys(states.checks);
	let title0 = "毎日の売上レポート";
	if( states.checks.daily ){
		title0 += "【"+String(states.checks.daily_hour)+"時】";
	}
	let title3 = "在庫僅少のお知らせ";
	if( states.checks.remaining ){
		title3 += "【"+String(states.checks.min_remaining)+"個以下】";
	}
	const menus:Listset[] = [
		{id:menuKeys[0],primary:title0,secondary:"24時間以内に売上があったら毎日指定の時間にお知らせします"},
		{id:menuKeys[1],primary:"先週の売上レポート",secondary:"先週の売上をまとめて毎週月曜日の昼頃にお知らせします"},
		{id:menuKeys[2],primary:"完売のお知らせ",secondary:"商品が完売したら翌日の午前7時頃にお知らせします"},
		{id:menuKeys[3],primary:title3,secondary:"指定した数より在庫が少なくなったら翌日の午前7時頃にお知らせします"},
		{id:menuKeys[4],primary:"在庫復活のお知らせ",secondary:"キャンセルで商品在庫が復活したらすぐにお知らせします"},
		{id:menuKeys[5],primary:"抽選受付開始のお知らせ",secondary:"抽選販売の受付が始まったらすぐにお知らせします"},
		{id:menuKeys[6],primary:"抽選完了のお知らせ",secondary:"抽選販売の受付が締め切られ抽選処理が完了したら、すぐにお知らせします"},
	];
	//console.log(menuKeys);
	const toMypage = process.env.REACT_APP_STOREURL + "/mypage_index.html";

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}
	
	return (
		<div id="profile_detail" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="メール通知" icon="mail"/>
                        <div style={{marginBottom:"2em"}}>
                            売上レポートや完売時のお知らせなどをメールで受け取れます。<br/>
                            最初は全部「通知なし」に設定されていますので、必要なものをタップして「あり」に切り替えてください。<br/>
                        </div>
						<List>
							{menus.map((data:Listset,index:number)=>{
								const key = "menu"+index;
								const name = menuKeys[index] as keyof OwnerMails;
								const checked = states.checks[name];
								let style = "#CCCCCC";
								if( checked ){
									style = Theme.palette.primary.main;
								}
								return (
							<ListItemButton key={key} style={{paddingLeft:'0',paddingBottom:'1em'}} onClick={()=>changeChecked(index)}>
                  				<ListItemAvatar>
									{checked ? (
                    				<Avatar style={{backgroundColor:`${style}`}}>
                      					<MarkEmailReadIcon style={{color:`white`}}/>
										<Box style={{fontSize:'60%'}}>あり</Box>
                    				</Avatar>
									):(
                    				<Avatar style={{backgroundColor:`${style}`}}>
										<Box style={{fontSize:'60%'}}>なし</Box>
                      					<EmailIcon/>
                    				</Avatar>
									)
									}
                  				</ListItemAvatar>
                  				<ListItemText
                    				primary={data.primary}
                    				secondary={data.secondary}
                  				/>
                			</ListItemButton>
								)
							})}
						</List>

                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
                        <RowData name="作家名" value={owner_name}/>
                        <RowData name="会員名" value={props.owner.customer.name}/>
						<Divider style={{margin:"1em 0"}}/>
						<div>
							<div style={{color:'#666666'}}>メールアドレス</div>
							<div className={classes.yourMail}>{props.owner.customer.mail}</div>
						</div>
                        <Divider style={{margin:"1em 0"}}/>
                        <FormControl fullWidth={true} style={{marginBottom:"1em"}}>
							<a href={toMypage}><Button variant="contained" color="primary" style={{width:"100%"}}><ArrowForwardIcon style={{marginRight:"0.5em"}}/>マイページへ行く</Button></a>
                        </FormControl>
                        <ul style={{paddingLeft:"1.5em",paddingRight:"0.5em"}}>
							<li>通知メールを受け取るメールアドレスはマイページで変更できます</li>
							<li>メールの送信タイミングはあくまで目安です。実際にはサーバーの混雑状況により数分から数十分程度遅れる場合があります。</li>
                            <li>不明な点がございましたら「ご利用ガイド」をご覧いただくか、お問い合わせ下さい</li>
                        </ul>
                        <div style={{textAlign:'right'}}>
                            <Link to='/first/p4b'><Button variant="text" color="primary" startIcon={<ArrowForwardIcon/>}>ご利用ガイド</Button></Link>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
            <Loading isLoading={states.isLoading}/>
			<MailsHour isOpen={states.isMailsHour} value={states.checks.daily_hour} close={closeMailsHour} update={updateMailsHour}/>
			<MailsRemaining isOpen={states.isMailsRemaining} value={states.checks.min_remaining} close={closeMailsRemaining} update={updateMailsRemaining}/>
		</div>
	);
}

export default Mails;
